import { Box, Button, Stack, Typography } from '@mui/material';
import OperationProductCard from 'components/shared/operation/OperationProductCard/OperationProductCard';

const ExitList = ({
  products = [],
  canMutate = false,
  actionLoading = false,
  onAutoInitAll,
  onTakeProduct,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        gap={1}
        flexWrap="wrap"
      >
        {canMutate ? (
          <Button
            size="small"
            variant="contained"
            loading={actionLoading}
            onClick={onAutoInitAll}
            disabled={!products.length}
          >
            توزیع همه وظایف
          </Button>
        ) : null}
      </Stack>

      {!products.length ? (
        <Box
          sx={{
            border: '1px dashed',
            borderColor: 'divider',
            borderRadius: 2,
            p: 4,
            textAlign: 'center',
          }}
        >
          <Typography color="text.secondary">
            محصولی در لیست جمع‌آوری نیست.
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
              xl: 'repeat(4, 1fr)',
            },
            gap: 2,
          }}
        >
          {products.map(product => (
            <OperationProductCard
              key={product.guid || product.operationProductGuid || product.id}
              product={product}
              canMutate={canMutate}
              actionLabel={canMutate ? 'برداشت' : undefined}
              onAction={onTakeProduct}
              actionDisabled={actionLoading}
            >
              {product.code ? (
                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: 500,
                    color: 'text.secondary',
                  }}
                >
                  {product.code}
                </Typography>
              ) : null}
            </OperationProductCard>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ExitList;
